import { Messages } from '../../../../../../gen-src/Localize';
import { FieldDataType, FieldRole, FieldRoleCategory } from '../../../../../../gen-src/queries';

export const FieldDataTypeMappings: Record<FieldDataType, () => string> = {
  BOOLEAN: Messages.FieldDataType_Boolean,
  DATE: Messages.FieldDataType_Date,
  DATETIME: Messages.FieldDataType_Datetime,
  INTEGER: Messages.FieldDataType_Integer,
  REAL: Messages.FieldDataType_Real,
  SPATIAL: Messages.FieldDataType_Spatial,
  STRING: Messages.FieldDataType_String,
  TUPLE: Messages.FieldDataType_Tuple,
  TABLE: Messages.FieldDataType_Table,
  UNKNOWN: Messages.FieldDataType_Unknown
};

export const FieldRoleMappings: Record<FieldRole, () => string> = {
  DIMENSION: Messages.FieldRole_Dimension,
  MEASURE: Messages.FieldRole_Measure,
  UNKNOWN: Messages.FieldRole_Unknown
};

export const FieldRoleCategoryMappings: Record<FieldRoleCategory, () => string> = {
  NOMINAL: Messages.FieldRoleCategory_Nominal,
  ORDINAL: Messages.FieldRoleCategory_Ordinal,
  QUANTITATIVE: Messages.FieldRoleCategory_Quantitative,
  UNKNOWN: Messages.FieldRoleCategory_Unknown
};
